<div fxLayout="row" class="container">
  <div
    fxFlex
    fxLayout="column"
    fxLayoutGap="8"
    class="panel mat-elevation-z4 inline"
  >
    <div
      fxFlex
      fxLayout="row"
      fxLayoutGap="4"
      *ngFor="let item of props.items; let idx = index"
      [ngClass]="item.isValid ? '' : 'invalid'"
    >
      <div fxFlex class="toggle">
        <mat-slide-toggle [disabled]="!props.isActive"
        [(ngModel)]="item.active"></mat-slide-toggle>
      </div>
      <div fxFlex>
        <mat-form-field>
          <mat-label>DIA</mat-label>
          <mat-select
            [disabled]="!props.isActive || !item.active"
            [(ngModel)]="item.day"
            name="food"
          >
            <mat-option *ngFor="let day of days" [value]="day.value">
              {{ day.viewValue }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
      <div fxFlex>
        <mat-form-field class="input" appearance="outline">
          <mat-label>INÍCIO</mat-label>
          <input
            [disabled]="!props.isActive || !item.active"
            type="time"
            matInput
            class="uppercase"
            [(ngModel)]="item.startTime"
          />
        </mat-form-field>
      </div>
      <div fxFlex>
        <mat-form-field class="input" appearance="outline">
          <mat-label>FIM</mat-label>
          <input
            [disabled]="!props.isActive || !item.active"
            type="time"
            matInput
            class="uppercase"
            [(ngModel)]="item.endTime"
            (change)="endTimeValidate(idx, item.startTime, item.endTime)"
          />
        </mat-form-field>
      </div>
      <div fxFlex class="delete-icon">
        <mat-icon
          class="action-icon delete-icon"
          [ngClass]="{ disable: !props.isActive || !item.active }"
          matRipple
          fontIcon="delete"
          (click)="remove(idx)"
        ></mat-icon>
      </div>
    </div>
  </div>
  <div fxFlex="initial" class="add-icon">
    <mat-icon
    [ngClass]="{ disable: !props.isActive }"
      class="action-icon"
      matRipple
      fontIcon="add_box"
      (click)="add()"
    ></mat-icon>
  </div>
</div>
